import { render } from "./EditImage.vue?vue&type=template&id=f8808144&scoped=true&ts=true"
import script from "./EditImage.vue?vue&type=script&lang=ts"
export * from "./EditImage.vue?vue&type=script&lang=ts"

import "./EditImage.vue?vue&type=style&index=0&id=f8808144&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8808144"]])

export default __exports__